import { apiRequest } from "./apiClient";
import type { PaginatedRecommendationActivityResponse } from "../types/recommendationActivity";

export type FetchReviewActivityParams = {
  readonly page?: number;
  readonly pageSize?: number;
  readonly mine?: boolean;
};

export async function fetchAiSuggestionReviewActivity(
  generatedContractId: string,
  params: FetchReviewActivityParams = {}
): Promise<PaginatedRecommendationActivityResponse> {
  const page = params.page ?? 1;
  const pageSize = params.pageSize ?? 20;
  const mine = params.mine ?? false;
  const q = new URLSearchParams({
    page: String(page),
    page_size: String(pageSize),
    mine: String(mine)
  });
  const response = await apiRequest(
    `/generated-contracts/${encodeURIComponent(generatedContractId)}/ai-suggestion-review-activity?${q.toString()}`
  );
  return (await response.json()) as PaginatedRecommendationActivityResponse;
}
